"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteVariableDynamoMapper = void 0;
const dynamodb_mapper_1 = require("../dynamodb-mapper");
const site_variable_json_1 = require("./site-variable-json");
exports.SiteVariableDynamoMapper = (0, dynamodb_mapper_1.createDynamoMapper)('SiteVariable', site_variable_json_1.SiteVariableJsonMapper);
